<ion-header class="ion-no-border">

    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="close()">
                <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>Filter payments and refunds</ion-title>
        <ion-buttons slot="end">
            <ion-button (click)="filterOrders()">
                <fa-icon [icon]="['far', 'check']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

</ion-header>

<ion-content>

    <ion-grid class="form">
        <ion-row>
            <ion-col>
                <ion-grid class="fieldset">
                    <ion-row >
                        <ion-col>
                            <ion-input *ngIf="search_params['from_date'] && search_params['from_date'].length != 0" class="modal-input" readonly="true" label="From date" labelPlacement="stacked" fill="outline" value={{formatted_from_date}} (click)="presentFromDateTimePickerModal()"></ion-input>
                            <ion-input *ngIf="!search_params['from_date'] || search_params['from_date'].length == 0" class="modal-input" readonly="true" label="From date" labelPlacement="stacked" fill="outline" (click)="presentFromDateTimePickerModal()"></ion-input>
                        </ion-col>
                    </ion-row>
                    <ion-row >
                        <ion-col>
                            <ion-input *ngIf="search_params['to_date'] && search_params['to_date'].length != 0" class="modal-input" readonly="true" label="To date" labelPlacement="stacked" fill="outline" value={{formatted_to_date}} (click)="presentToDateTimePickerModal()"></ion-input>
                            <ion-input *ngIf="!search_params['to_date'] || search_params['to_date'].length == 0" class="modal-input" readonly="true" label="To date" labelPlacement="stacked" fill="outline" (click)="presentToDateTimePickerModal()"></ion-input>
                        </ion-col>
                    </ion-row>
                    <ion-row>
                        <ion-col>
                            <ion-select cancelText="Cancel" okText="OK" interface="alert" label="Currency" labelPlacement="stacked" fill="outline" [(ngModel)]="search_params['currency_id']">
                                <ion-select-option *ngFor="let currency of supported_currencies" value="{{currency.id}}">{{currency.title}}</ion-select-option>
                            </ion-select>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-col>
        </ion-row>
    </ion-grid>

</ion-content>